import type { SVGProps } from "react";
// generated from ArrowNext.svg — do not edit manually
// prettier-ignore
export default function ArrowNext(props: SVGProps<SVGSVGElement>) {
  return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}><path d="M 13 5 L 20 12 M 20 12 L 13 19 M 20 12 L 4 12" stroke="currentColor" strokeWidth="1.5"/></svg>);
}
